import React from "react";
import logoImg from "../assets/logo.png";

export const LogoSimple = ({ size = 120 }) => (
  <div
    className="relative rounded-full bg-white flex flex-col items-center justify-center text-center shadow-card"
    style={{ width: size, height: size }}
  >
    <Rainbow className="w-9 h-6 -mb-0.5" />
    <span className="font-display font-semibold text-forest leading-tight" style={{ fontSize: size * 0.155 }}>
      Neni’s
    </span>
    <span className="font-display font-semibold text-forest leading-tight" style={{ fontSize: size * 0.155 }}>
      Playhouse
    </span>
    <span className="tracking-[0.14em] text-[#9B6BD1] font-bold" style={{ fontSize: size * 0.08 }}>
      CHILD CARE
    </span>
  </div>
);

export const Butterfly = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <ellipse cx="13" cy="16" rx="8" ry="11" fill="#F9A8D4" transform="rotate(-20 13 16)" />
    <ellipse cx="27" cy="16" rx="8" ry="11" fill="#C4B5FD" transform="rotate(20 27 16)" />
    <circle cx="20" cy="20" r="3" fill="#7C4DBE" />
    <path d="M18 12c-1-3-3-4-5-4M22 12c1-3 3-4 5-4" stroke="#7C4DBE" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const Rainbow = ({ className = "", opacity = 1 }) => (
  <svg viewBox="0 0 120 70" fill="none" className={className} style={{ opacity }} aria-hidden="true">
    <path d="M18 64a42 42 0 0 1 84 0" stroke="#F9A8D4" strokeWidth="9" strokeLinecap="round" />
    <path d="M31 64a29 29 0 0 1 58 0" stroke="#8CE0C5" strokeWidth="9" strokeLinecap="round" />
    <path d="M44 64a16 16 0 0 1 32 0" stroke="#FBD85A" strokeWidth="9" strokeLinecap="round" />
  </svg>
);

export const DotRainbow = ({ className = "" }) => (
  <svg viewBox="0 0 200 118" fill="none" className={className} aria-hidden="true">
    <path d="M30 110a70 70 0 0 1 140 0" stroke="#F178B4" strokeWidth="13" strokeLinecap="round" strokeDasharray="0.1 19" fill="none" />
    <path d="M48 110a52 52 0 0 1 104 0" stroke="#FFF8F0" strokeWidth="13" strokeLinecap="round" strokeDasharray="0.1 19" fill="none" />
    <path d="M66 110a34 34 0 0 1 68 0" stroke="#FBD85A" strokeWidth="13" strokeLinecap="round" strokeDasharray="0.1 19" fill="none" />
  </svg>
);

export const Garland = ({ className = "" }) => (
  <svg viewBox="0 0 220 36" fill="none" preserveAspectRatio="none" className={className} aria-hidden="true">
    {Array.from({ length: 8 }).map((_, i) => (
      <g key={i}>
        <line x1={14 + i * 28} y1="0" x2={14 + i * 28} y2="20" stroke="#5FA88C" strokeWidth="2" />
        <circle
          cx={14 + i * 28}
          cy="25"
          r="5"
          fill={["#FFFFFF", "#FBD85A", "#F178B4", "#8CE0C5", "#FFFFFF", "#FBD85A", "#F178B4", "#8CE0C5"][i]}
        />
      </g>
    ))}
  </svg>
);

export const BlobCheck = ({ color = "#D8E2EE", className = "" }) => (
  <div className={`relative w-16 h-16 shrink-0 ${className}`} aria-hidden="true">
    <svg viewBox="0 0 64 64" className="absolute inset-0 w-full h-full">
      <path d="M32 3c9-2 19 1 24 8s6 17 2 25-13 14-23 14S14 46 9 38 2 20 8 12 23 5 32 3Z" fill={color} />
    </svg>
    <svg viewBox="0 0 24 24" className="absolute inset-0 m-auto w-7 h-7" fill="none">
      <path d="M5 13l4 4L19 7" stroke="#FFFFFF" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);

export const Polaroid = ({ src, alt, className = "", testid }) => (
  <div className={`relative bg-[#DFAF8C] p-2.5 shadow-card ${className || ""}`}>
    <div className="bg-white p-1.5">
      <img data-testid={testid} src={src} alt={alt} className="w-full aspect-[4/5] object-cover" />
    </div>
  </div>
);

export const StickerBest = ({ className = "" }) => (
  <div className={`absolute -right-4 -bottom-8 rotate-6 ${className || ""}`} aria-hidden="true">
    <svg viewBox="0 0 170 112" className="w-32 sm:w-36 drop-shadow-lg">
      <path
        d="M30 18C48 2 88 0 112 10c26 10 44 28 42 52-2 24-26 42-56 44-30 2-60-8-72-26C14 62 14 34 30 18Z"
        fill="#F178B4"
      />
      <text x="82" y="50" textAnchor="middle" fill="#FFF8F0" fontFamily="Fredoka, sans-serif" fontWeight="600" fontSize="27" transform="rotate(-4 82 55)">
        You’re the
      </text>
      <text x="82" y="86" textAnchor="middle" fill="#FFF8F0" fontFamily="Fredoka, sans-serif" fontWeight="700" fontSize="34" transform="rotate(-4 82 55)">
        BEST!
      </text>
      <g stroke="#FFF8F0" strokeWidth="4" strokeLinecap="round">
        <line x1="138" y1="20" x2="146" y2="10" />
        <line x1="150" y1="32" x2="162" y2="26" />
      </g>
    </svg>
  </div>
);

export const Cloud = ({ className = "", style }) => (
  <svg viewBox="0 0 90 50" fill="none" className={className} style={style} aria-hidden="true">
    <path
      d="M22 42c-8 0-14-5.5-14-12.5S14 17 21.5 17.5C24 10.5 31 5.5 39.5 5.5 50 5.5 58.5 13 59.5 22.5c7-.5 13.5 4.5 13.5 11 0 5-4.5 8.5-10 8.5H22Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const Flower = ({ className = "", petal = "#F9B8C6", center = "#FFD97A" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    {[0, 60, 120, 180, 240, 300].map((deg) => (
      <ellipse key={deg} cx="20" cy="9" rx="6" ry="9" fill={petal} transform={`rotate(${deg} 20 20)`} />
    ))}
    <circle cx="20" cy="20" r="6.5" fill={center} />
  </svg>
);

export const Sun = ({ className = "" }) => (
  <svg viewBox="0 0 60 60" fill="none" className={className} aria-hidden="true">
    {Array.from({ length: 8 }).map((_, i) => (
      <line
        key={i}
        x1="30"
        y1="4"
        x2="30"
        y2="12"
        stroke="#F5C86A"
        strokeWidth="4"
        strokeLinecap="round"
        transform={`rotate(${i * 45} 30 30)`}
      />
    ))}
    <circle cx="30" cy="30" r="12" fill="#FFD97A" />
  </svg>
);

export const Sparkle = ({ className = "", color = "#354B3E" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <path d="M20 4v12M20 24v12M4 20h12M24 20h12" stroke={color} strokeWidth="3.4" strokeLinecap="round" />
    <path d="M9 9l6 6M25 25l6 6M31 9l-6 6M15 25l-6 6" stroke={color} strokeWidth="2.4" strokeLinecap="round" opacity="0.6" />
  </svg>
);

export const Planet = ({ className = "", color = "#B8D8BD" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="17" fill={color} />
    <circle cx="18" cy="19" r="3" fill="#FAF8F1" opacity="0.8" />
    <circle cx="28" cy="28" r="2.2" fill="#FAF8F1" opacity="0.7" />
    <circle cx="30" cy="16" r="1.8" fill="#FAF8F1" opacity="0.6" />
  </svg>
);

export const Rocket = ({ className = "" }) => (
  <svg viewBox="0 0 60 60" fill="none" className={className} aria-hidden="true">
    <path
      d="M30 6c8 6 12 16 12 26l-6 8H24l-6-8c0-10 4-20 12-26Z"
      stroke="#354B3E"
      strokeWidth="3"
      strokeLinejoin="round"
      fill="#DCEEDB"
    />
    <circle cx="30" cy="24" r="5" stroke="#354B3E" strokeWidth="3" fill="#FAF8F1" />
    <path d="M18 34 8 44l10 2M42 34l10 10-10 2" stroke="#354B3E" strokeWidth="3" strokeLinejoin="round" />
  </svg>
);

export const DashedPath = ({ className = "" }) => (
  <svg viewBox="0 0 300 140" fill="none" className={className} preserveAspectRatio="none" aria-hidden="true">
    <path
      d="M6 30c60 90 130-60 180 10 30 44 60 30 108 60"
      stroke="#354B3E"
      strokeWidth="3"
      strokeLinecap="round"
      strokeDasharray="1 14"
      opacity="0.5"
    />
  </svg>
);

export const ScallopDivider = ({ fill = "#DCEEDB", className = "", flip = false }) => {
  const bumps = 12;
  const w = 1200 / bumps;
  let d = `M0 34`;
  for (let i = 0; i < bumps; i++) {
    d += ` Q ${i * w + w / 2} -14 ${i * w + w} 34`;
  }
  d += ` L1200 70 L0 70 Z`;
  return (
    <svg
      viewBox="0 0 1200 70"
      preserveAspectRatio="none"
      className={`block w-full h-[46px] sm:h-[64px] ${flip ? "rotate-180" : ""} ${className}`}
      aria-hidden="true"
    >
      <path d={d} fill={fill} />
    </svg>
  );
};

export const WaveDivider = ({ fill = "#FAF8F1", className = "" }) => (
  <svg viewBox="0 0 1440 70" preserveAspectRatio="none" className={`block w-full h-[40px] sm:h-[56px] ${className}`} aria-hidden="true">
    <path
      d="M0 40 C240 90 480 -10 720 30 C960 70 1200 20 1440 45 L1440 70 L0 70 Z"
      fill={fill}
    />
  </svg>
);

export const LogoBadge = ({ size = 84 }) => (
  <img
    src={logoImg}
    alt="Neni’s Playhouse Childcare logo"
    className="rounded-full shadow-card bg-white"
    style={{ width: size, height: size, border: "3px solid #FFFFFF" }}
  />
);

const flowerMask = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"><g fill="#000"><circle cx="120" cy="120" r="70"/>${Array.from({ length: 8 })
    .map((_, i) => `<circle cx="120" cy="56" r="38" transform="rotate(${i * 45} 120 120)"/>`)
    .join("")}</g></svg>`
)}")`;

export const PhotoCard = ({ src, alt, className = "", color = "#F9C6E3", testid, imgClassName = "h-auto" }) => (
  <div className={`rounded-[2.75rem] p-2 shadow-card ${className || ""}`} style={{ background: color }}>
    <div className="bg-white rounded-[2.25rem] p-2.5">
      <img data-testid={testid} src={src} alt={alt} className={`block w-full rounded-[1.5rem] ${imgClassName}`} />
    </div>
  </div>
);

export const FlowerFrame = ({ src, alt, className = "", color = "#F9C6E3", testid }) => {
  const mask = {
    WebkitMaskImage: flowerMask,
    maskImage: flowerMask,
    WebkitMaskSize: "100% 100%",
    maskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
  };
  return (
    <div className={`relative aspect-square ${className}`} style={{ ...mask, background: color }} role="img" aria-label={alt}>
      <div className="absolute inset-[4%]" style={{ ...mask, background: "#FFFFFF" }}>
        <div className="absolute inset-[5%]" style={{ ...mask, background: "#FFFFFF" }}>
          <img data-testid={testid} src={src} alt="" className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  );
};
